function BookNewAppointment() {
  return (
    <div className="main-container">
      <div className="main-heading">
        <h1> Book new appointment</h1>
      </div>
    </div>
  );
}

export default BookNewAppointment;
